import axios from "axios"
import { URL_BASE, URL_COOKIE } from '../../../config/config'

// Habilita envio de cookies em requisições cross-origin
axios.defaults.withCredentials = true

const RESOURCE = 'financials'

export default {
    state: {
        me: {},
        authenticated: false,
        urlBack: 'login',
    },

    mutations: {
        AUTH_USER_OK (state, user) {
            state.authenticated = true
            state.me = user
        },

        AUTH_USER_LOGOUT (state) {
            state.me = {}
            state.authenticated = false
            state.urlBack = 'login'
        },

        CHANGE_URL_BACK (state, url) {
            state.urlBack = url
        },
    },

    actions: {
        // 1. Login
        async login (context, params) {
            context.commit('PRELOADER', true)
            try {
                // Passo 1: obter CSRF cookie (do domínio da API)
                await axios.get(URL_COOKIE);

                // Passo 2: login na mesma URL de antes
                const url = URL_BASE + 'authfinancial'
                const response = await axios.post(url, params)

                context.commit('AUTH_USER_OK', response.data.user)
            } finally {
                context.commit('PRELOADER', false)
            }
        },

        // 2. Verificar login
        async checkLogin (context) {
            context.commit('PRELOADER', true)
            try {
                // Mesma URL de antes
                const url = URL_BASE + 'financials/me'
                const response = await axios.get(url)
                context.commit('AUTH_USER_OK', response.data.data)
            } catch (error) {
                context.dispatch('logout')
                throw error
            } finally {
                context.commit('PRELOADER', false)
            }
        },

        // 3. Logout
        async logout (context) {
            context.commit('PRELOADER', true)
            try {
                await axios.post(URL_BASE + 'financials/logout_financial')
            } catch (e) {
                console.warn('Logout API failed')
            } finally {
                context.commit('AUTH_USER_LOGOUT')
                window.location.href = "/login"
                context.commit('PRELOADER', false)
            }    
        },

        // 4. Refresh (se necessário)
        async refreshMe (context, id) {
            context.commit('PRELOADER', true)
            try {
                const response = await axios.get(`${URL_BASE}${RESOURCE}/${id}`)
                context.commit('AUTH_USER_OK', response.data.data)
            } finally {
                context.commit('PRELOADER', false)
            }
        },
    },
}